import { render, staticRenderFns } from "./UltimaCarga.vue?vue&type=template&id=67c4ba06&scoped=true"
import script from "./UltimaCarga.vue?vue&type=script&lang=js"
export * from "./UltimaCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c4ba06",
  null
  
)

export default component.exports